/* ==========================================================================
   ZELICAT THEME — blog.js
   Blog listing: topic filter without a page reload (port of the mockup's initBlogFilter).
   The chips are real links (/blogs/<blog>/tagged/<tag>), so everything also works without JS.
   The instant filter only runs when every article is already on the page
   (one page of results and no tag selected); otherwise the links are followed normally.
   ========================================================================== */
(() => {
  'use strict';
  if (!window.ZC) return;
  const { $, $$ } = window.ZC;

  ZC.mount(() => {
    const grid = $('[data-blog-grid]');
    if (!grid || grid.getAttribute('data-filter-local') !== 'true') return;

    const posts = $$('[data-topic-of]', grid);
    const note = $('[data-blog-note]', grid);
    const count = $('[data-count-live]');
    const label = $('[data-count-label]');
    const none = $('[data-blog-none]');
    const noneDefault = none ? none.textContent : '';

    const apply = (key) => {
      let n = 0;
      posts.forEach((p) => {
        const topics = (p.getAttribute('data-topic-of') || '').split(/\s+/);
        const show = key === 'all' || topics.indexOf(key) !== -1;
        p.hidden = !show;
        if (show) n += 1;
      });
      $$('[data-topic]').forEach((b) => {
        const on = b.getAttribute('data-topic') === key;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      if (count) count.textContent = String(n);
      if (label) label.textContent = n === 1 ? label.getAttribute('data-one') : label.getAttribute('data-other');
      if (none) {
        none.hidden = n > 0;
        if (n === 0) none.textContent = none.getAttribute('data-topic-text') || noneDefault;
      }
      if (note) note.hidden = key !== 'all';
    };

    $$('[data-topic]').forEach((chip) => {
      if (!ZC.once(chip, 'topic')) return;
      chip.addEventListener('click', (e) => {
        // let the browser handle modified clicks (new tab, etc.)
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
        const liveGrid = $('[data-blog-grid][data-filter-local="true"]');
        if (!liveGrid) return;
        e.preventDefault();
        apply(chip.getAttribute('data-topic'));
      });
    });
  });
})();
